import Image from "next/image";

import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";

import Heading from "sections/nfcTagsPage/Heading";
import ContactForm from "sections/nfcTagsPage/ContactForm";

import styles from "./styles";

interface ContactSectionProps {
  heading?: string;
  subheading?: string;
  boxProps?: BoxProps;
}

const ContactSection: FC<ContactSectionProps> = ({
  heading = "Start your NFC journey!",
  subheading = "Get NFC tags now! Fill out the form, and we'll get in touch. Once you receive your tags, attach them to your products and unlock a new digital experience. It's the perfect time to digitalize—try it today!",
  boxProps,
}) => {
  return (
    <Box component="section" display="grid" {...boxProps}>
      <Box sx={styles.imageWrapper}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/uq.gif`}
          width={1475}
          height={599}
          alt=""
          style={{
            width: "100%",
            objectFit: "contain",
            height: "auto",
          }}
        />
      </Box>

      <Heading heading={heading} subheading={subheading} />

      <ContactForm />
    </Box>
  );
};

export default ContactSection;
